import { MissingTranslationsDevTools } from "./__internals__/dev-tools-component";
import { addMissingTranslation } from "./__internals__/store";

export { addMissingTranslation, MissingTranslationsDevTools };
